const minin = {
  data() {
    return {
      form: {
        repaytime: null,
        istime: '2',
        inton: undefined,
        unton: undefined,
      },
      // 基础信息
      formCtrl: [
        {
          label: "运单编号",
          keyName: "order_num",
          err: "请填写运单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "合同编号",
          keyName: "con_num",
          err: "请填写合同编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请填写货物名称",
          type: "text",
          viewMode: true,
        },
      ],
      // 装货信息
      formCtrlIn: [
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
        },
        {
          label: "装货联系人",
          keyName: "drman",
          err: "请填写装货联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "drtel",
          err: "请填写联系电话",
          type: "text",
        },
        {
          ...this.ctrls.ZhuangHuoRiQi,
        },
      ],
      // 卸货信息
      formCtrlOut: [
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
        },
        {
          label: "卸货联系人",
          keyName: "enman",
          err: "请填写卸货联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "ertel",
          err: "请填写联系电话",
          type: "text",
        },
        {
          ...this.ctrls.XieHuoRiQi,
        },
      ],
      // 运单信息
      formCtrlOrder: [
        {
          label: "计价方式",
          keyName: "pricing_name",
          type: "select",
          options: [],
        },
        {
          label: "公司单价",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number",
        },
        {
          label: "司机单价",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number",
        },
        {
          label: "装货量",
          keyName: "inton",
          err: "请填写装货量",
          type: "text",
        },
        {
          label: "卸货量",
          keyName: "unton",
          err: "请填写卸货量",
          type: "text",
        },
      ],
      kuitonCtrl: {
        label: "亏吨重量",
        keyName: "kuiton",
        err: "请填写亏吨重量",
        type: "text",
        viewMode: true,
      },
      formCtrlOrder2: [
        {
          label: "装货单",
          keyName: "invoice",
          err: "请填写装货单",
          type: "file",
          ptype: "order",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 1,
        },
        {
          label: "卸货单",
          keyName: "uninvoice",
          err: "请填写卸货单",
          type: "file",
          ptype: "order",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 1,
          className: "unton",
        },
      ],
      // 亏吨信息
      formCtrlWeight: [
        // {
        //   label: "亏吨协议单价",
        //   keyName: "unitprice",
        //   err: "请填写亏吨协议单价",
        //   type: "number",
        //   viewMode: true,
        // },
        // {
        //   label: "亏吨协议重量",
        //   keyName: "unitton",
        //   err: "请填写亏吨协议重量",
        //   type: "number",
        //   viewMode: true,
        // },
        {
          // label: "客户承担亏吨重量(吨)",
          label: "客担亏吨(吨)",
          keyName: "ceton",
          err: "请填写客担亏吨",
          type: "number",
        },
        {
          label: "亏吨单价(元/吨)",
          keyName: "dtonprice",
          err: "请填写亏吨单价",
          type: "number",
          tips: "不填写默认不计算亏吨金额",
        },
        // {
        //   label: "实际客户承担亏吨",
        //   keyName: "dceton",
        //   err: "请填写实际客户承担亏吨",
        //   type: "number",
        //   tips: "不填写无法计算出实际运费",
        // },
        // {
        //   label: "实际亏吨单价(元/吨)",
        //   keyName: "dtonprices",
        //   err: "请填写实际亏吨单价",
        //   type: "number",
        //   tips: "不填写无法计算出实际运费",
        // },
      ],
      // 预计结款日期
      formCtrl2: [
        {
          label: "预计结款日期",
          keyName: "repaytime",
          err: "请填写预计结款日期",
          type: "date",
          tips: "不填写则默认没有预计结款日期",
          // className: "block",
        },
      ],
      istimeCtrl: {
        label: "结款提醒",
        keyName: "istime_name",
        type: "text",
        viewMode: true,
      },
      // 运单备注
      formCtrl3: [
        {
          label: "运单备注",
          keyName: "order_remark",
          className: "order_remark",
          err: "请填写运单备注",
          // type: "text",
          type: "textarea",
        },
      ],
      // 附加费用
      formCtrlfee: [
        // {
        //   label: "信息费",
        //   keyName: "message",
        //   type: "number",
        // },
        // {
        //   label: "保险费",
        //   keyName: "insurance",
        //   type: "number",
        // },
        // {
        //   label: "燃油附加费",
        //   keyName: "fuel",
        //   type: "number",
        // },
        // {
        //   label: "超限附加费",
        //   keyName: "exceeded",
        //   type: "number",
        // },
      ],
      custom: [],
      product: [],
      // 计价方式选项
      pricing: [],
    };
  },
  methods: {
    updateStatus() {
      this.$confirm('确认审核通过吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateStatusReq();
      }).catch(() => { });
    },
    updateStatusReq() {
      this.loading = true
      let url = `${this.baseUrl}/updatestatus`;
      const params = {
        userid: this.user.id,
        id: this.id,
        isstatus: 4,
      }
      this.paramsPackage(params, this.form)
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '审核通过!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '审核通过失败，请稍后重试！'
        });
      })
    },
    checkInTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      // console.log(value == undefined || value == '', this.form.pricing_id != 5)
      // 只要不是‘按趟计费’（pricing_id为5），都要填写装货量
      if ((value == undefined || value == '') && this.form.pricing_id != 5) {
        callback(new Error('请填写装货量'));
      }
      // else if (Number(value) > 60) {
      //   callback(new Error('重量不能超过60吨'));
      // }
      else {
        callback();
      }
    },
    checkUnTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      // 只要不是‘按趟计费’（pricing_id为5），都要填写卸货量
      if ((value == undefined || value == '') && this.form.pricing_id != 5) {
        callback(new Error('请填写卸货量'));
      }
      // else if (Number(value) > 60) {
      //   callback(new Error('重量不能超过60吨'));
      // }
      else {
        callback();
      }
    },
    onToggle(boo) {
      // console.log(boo)
      boo ? (this.$set(this.form, 'istime', 1)) : (this.$set(this.form, 'istime', 2))
      // console.log('form', { ...this.form })
    },
    getAllCtrls() {
      const formCtrl = [...this.formCtrl]
      if (this.kuitonCtrl) {
        formCtrl.push(this.kuitonCtrl)
      }
      const In = this.formCtrlIn
      if (In && In.length) {
        formCtrl.push(...In)
      }
      const Out = this.formCtrlOut
      if (Out && Out.length) {
        formCtrl.push(...Out)
      }
      const Order = this.formCtrlOrder
      if (Order && Order.length) {
        formCtrl.push(...Order)
      }
      const Order2 = this.formCtrlOrder2
      if (Order2 && Order2.length) {
        formCtrl.push(...Order2)
      }
      const Weight = this.formCtrlWeight
      if (Weight && Weight.length) {
        formCtrl.push(...Weight)
      }
      const f2 = this.formCtrl2
      if (f2 && f2.length) {
        formCtrl.push(...f2)
      }
      const f3 = this.formCtrl3
      if (f3 && f3.length) {
        formCtrl.push(...f3)
      }
      const ff = this.formCtrlfee
      if (ff && ff.length) {
        formCtrl.push(...ff)
      }
      return formCtrl
    },
    setDetail() {
      const formCtrl = this.getAllCtrls()
      formCtrl.map(v => {
        const key = v.keyName
        // 按趟计费不可编辑装/卸货量
        // if (this.form['pricing_id'] == 5 && ['inton', 'unton'].includes(key)) {
        //   v.viewMode = true
        // }
        // console.log(key)
        // console.log(v)
        if (['kuiton'].includes(key) && v.viewMode) {
          this.$set(this.form, key, `${this.detail[key]}吨`)
        } else if (['message'].includes(key) && v.viewMode) {
          // console.log(v)
          this.$set(this.form, key, `${this.detail[key]}元`)
        } else if (['order_remark'].includes(key)) {
          // console.log(v)
          // console.log(this.detail[key])
          this.$set(this.form, key, this.detail[key])
          this.$nextTick(() => {
            // console.log(this.$refs)
            if (this.$refs && this.$refs.form3Item0) {
              const dom = this.$refs.form3Item0[0].$el
              // console.log(dom)
              const inner = dom.querySelector('.el-textarea__inner')
              if (!inner) return
              // console.log(inner)
              // console.log(inner.scrollHeight)
              inner.style.height = 'auto'; // 重置高度
              inner.style.height = inner.scrollHeight + 'px'; // 设置为内容高度
            }
          })
        } else {
          this.$set(this.form, key, this.detail[key])
        }
      })

      if (this.detail['shipperid']) {
        this.$set(this.form, 'shipperid', this.detail['shipperid'])
      }

      if (this.detail['nid']) {
        this.$set(this.form, 'nid', this.detail['nid'])
      }

      // 设置pricing_name，pricing_id
      this.setPricingName()

      if (this.form['repaytime']) {
        this.$set(this.form, 'istime', this.detail['istime'])
      }
      if (this.form['istime'] == 1) {
        this.$set(this.form, 'istime_name', '开启')
      } else {
        this.$set(this.form, 'istime_name', '关闭')
      }

      // 附加费用
      const extraFee = this.detail['additional_fee_options']
      if (extraFee && extraFee.length) {
        if (!this.form['additional_fee_items']) {
          this.form['additional_fee_items'] = []
        }
        this.formCtrlfee = []
        extraFee.map(v => {
          // 渲染表单控件
          const ctrl = {
            label: v.authname,
            keyName: v.enname,
            type: "number",
          }
          this.formCtrlfee.push(ctrl)

          // 添加回显值
          this.form[v.enname] = v.money

          // 添加提交数据
          this.form['additional_fee_items'].push({
            id: `${v.id}`,
            money: v.money,
          })
        })
      }
      this.$forceUpdate()
      // console.log('detail', { ...this.detail })
      // console.log('form', { ...this.form })
    },
    paramsPackage(params, object) {
      const keys = this.getAllCtrls().map(v => v.keyName)
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) &&
          [
            ...keys,
            'car_list', // 合同运单派单
            'shipperid',
            'nid',
            'pricing_id',
            'istime',
            'additional_fee_items',
            'd_id',
          ].includes(key)) {
          // console.log(key, object[key], typeof object[key])
          const value = object[key]
          // console.log(value)
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else if (typeof value === 'string' && value.includes('元')) {
            params[key] = value.replace('元', '')
          } else if (typeof value === 'string' && value.includes('吨')) {
            params[key] = value.replace('吨', '')
          } else {
            params[key] = value;
          }
        }
      }
      // 货物id，提交时需要回传
      // if (!params['nid']) {
      //   params['nid'] = this.detail['nid'];
      // }
      // 派单不传id
      // if (!location.href.includes('add')) {
      //   params['id'] = this.detail['id'];
      // }
      if (this.detail['contractid']) {
        params['contractid'] = this.detail['contractid'];
      }
      // 为了防止丢掉shipperid，再赋值一遍，因为派单的客户名称实际值改成shname了
      // console.log(params['shipperid'], this.detail['shipperid'])
      // if (!params['shipperid']) {
      //   this.$set(params, 'shipperid', this.detail['shipperid'])
      // }
      delete params['pricing_name']
      this.$forceUpdate()
      // console.log('params', { ...params })
    },
    onInput({ key, value }) {
      console.log(key, value)
      if (key === 'order_remark') {
        if (this.$refs && this.$refs.form3Item0) {
          const dom = this.$refs.form3Item0[0].$el
          // console.log(dom)
          const inner = dom.querySelector('.el-textarea__inner')
          if (!inner) return
          // console.log(inner)
          // console.log(inner.scrollHeight)
          // const oheight = inner.scrollHeight
          inner.style.height = 'auto'; // 重置高度
          // 高度设为auto后scrollHeight会改变，用原始高度判断，一行时强制一行高度，其他情况随内容升高
          // if (oheight < 55) {
          //   inner.style.height = 40 + 'px'
          // } else {
          inner.style.height = inner.scrollHeight + 'px'; // 设置为内容高度
          // }
        }
      }
    },
    ExtraFeeChange(k, v) {
      // console.log('onChange', k, v)
      // console.log({ ...this.form })

      // 获取数字类型id
      const id = Number(k.replace('additional_fee_', ''))
      // 没有数组则添加
      if (!this.form['additional_fee_items']) {
        this.form['additional_fee_items'] = []
      }
      // 获取id数组进行匹配
      const arr = this.form['additional_fee_items'].map(c => Number(c.id))

      // console.log('arr', arr)

      if (arr.includes(id)) {
        // 匹配id赋值
        this.form['additional_fee_items'].map(c => {
          if (c.id == id) {
            c.money = Number(v)
          }
        })
      } else {
        // 没有则插入
        this.form['additional_fee_items'].push({
          id,
          money: Number(v),
        })
      }

      // console.log({ ...this.form })
    },
    onChange({ key, value }) {
      // console.log('onChange', key, value)
      // console.log(Number(value))
      if (key.includes('additional_fee')) {
        this.ExtraFeeChange(key, value)
      } else if (key === 'shname') {
        // console.log('onChange', key, value)
        this.$set(this.form, key, value)
        this.custom.map(v => {
          if (v.name + '-' + v.member === value) {
            this.$set(this.form, 'shipperid', v.id)
          }
        })
        // console.log(this.form[key])
      } else if (key === 'name') {
        // console.log('onChange', key, value)
        this.$set(this.form, key, value)
        this.product.map(v => {
          if (v.name === value) {
            this.$set(this.form, 'nid', v.id)
          }
        })
        // console.log(this.form[key])
      } else if (key === 'pricing_name') {
        this.$set(this.form, key, value)
        this.pricing.map(v => {
          if (value === v.name) {
            this.$set(this.form, 'pricing_id', v.id)
          }
        })
      } else if (['invoice', 'uninvoice'].includes(key) && value.length == 1 && value[0] && value[0].response) {
        this.$set(this.form, key, value[0].response.photo)
        // console.log(this.form[key])
      } else if (['identitycard', 'driverslicense', 'certificate', 'escortcard'].includes(key) || key.includes('photo') || (value && typeof value === 'object')) {
        const o = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
        this.$set(this.form, key, o)
      } else {
        this.$set(this.form, key, value)
      }
      // 表单赋值之后再计算亏吨重量
      if (['inton', 'unton'].includes(key)) {
        this.calcKuiton()
      }
      // console.log('form', { ...this.form });
    },
    calcKuiton() {
      const inton = this.form['inton'];
      const unton = this.form['unton'];
      // console.log(inton, unton)
      if (inton && unton) {
        this.$set(this.form, 'kuiton', (inton - unton).toFixed(2) + '吨')
      }
    },
    setDetailOrderData({ pricing }) {
      // 取 item 接口的 pricing 作为选项，不必再专门请求 options
      this.formCtrlOrder.map(c => {
        if (c.keyName == 'pricing_name') {
          this.setPricingOption(pricing, c.options)
          // console.log(this.detail['pricing_id'])
          if (!this.detail['pricing_id']) {
            this.$set(this.form, 'pricing_id', pricing[0]['id'])
            this.$set(this.form, 'pricing_name', pricing[0]['name'])
          } else {
            // 如果detail先到则在这里匹配
            this.setPricingName()
          }
        }
      })

      // console.log('form', { ...this.form });
    },
    /**
     * 设置计价方式选项
     * @param {Array} pricing 后台源数据
     * @param {Array} options 容器
     * @param {Object} prototype? 数据原型
     */
    setPricingOption(pricing, options, prototype) {
      // 源数据存在且有长度
      if (pricing && pricing.length) {
        // 储存一份
        this.pricing.push(...pricing)
        // console.log([...options])
        // 如果有数据则退回，防止重复注入
        if (options.length) return
        // 默认的label是name
        let key1 = 'name'
        // 可以通过原型覆盖label
        if (prototype && prototype.label) {
          key1 = prototype.label
        }
        // 默认的value是name
        let key2 = 'name'
        // 可以通过原型覆盖value
        if (prototype && prototype.value) {
          key2 = prototype.value
        }
        // 遍历储存
        pricing.map(v => {
          options.push({
            label: v[key1],
            value: v[key2],
          })
        })
      }
    },

    setPricingName(pricingId) {
      if (!this.detail['pricing_id']) {
        console.log('detail 还未获取到')
      }
      if (!this.pricing) {
        console.log('pricing 还未获取到')
      }
      const pricing_id = pricingId || this.detail['pricing_id']
      if (pricing_id && this.pricing && this.pricing.length) {
        this.pricing.map(v => {
          if (v.id == pricing_id) {
            this.$set(this.form, 'pricing_name', v['name'])
            // if (!this.form['pricing_id']) {
            this.form['pricing_id'] = pricing_id
            // }
          }
        })
      }
    },
  },
}

export default minin